export const haveOtherValue = (value: string | string[] | undefined) => 
  (value === 'Other' || (value && value.includes && value.includes('Other')))

export const getOptionFromEnum = (enumValues: string[]): { value: string, label: string}[] =>
  enumValues && enumValues.map((value: any) => ({
    label: value,
    value
  }))
